import { LogGroup, Log } from "../.././MyHelpers";
import { ReelSpinAnimation } from "../SpinAnimation/ReelSpinAnimation";
import { S2_ReelSpinAnimation } from "./ReelSpinAnimation";
import { S2_IReelConfig } from "./SpinnableReels";

// export namespace S2
// {
export class S2_SpinTarget {
	public position: number = 0;
	public anticipate: boolean = false;
}

export type S2_SpinCallback = () => void;

export class S2_SpinAnimation {

	private logGroup: LogGroup = null;
	protected reelConfig: S2_IReelConfig[] = null;
	protected reelAnimations: S2_ReelSpinAnimation[] = null;


	private onStartCallbacks: S2_SpinCallback[] = [];
	private onCompleteCallbacks: S2_SpinCallback[] = [];

	
	//private targetsSet: boolean = false;
	private stopRequested: boolean = false;
	private reelsFinished: number = 0;

	// reel animations must be sorted left to right
	public constructor(logGroup: LogGroup, reelConfig: S2_IReelConfig[], reelAnimations: S2_ReelSpinAnimation[]) {
		this.logGroup = logGroup.Add("SpinAnim");

		this.reelConfig = reelConfig;
		this.reelAnimations = reelAnimations;

		this.reelAnimations.forEach(anim => anim.AddOnCompleteCallback((anim) => this.ReelFinished(anim)))
	}

	// public AddReelAnimation(anim: ReelSpinAnimation): void {
	// 	// connect reel animations 
	// 	if (this.reelAnimations.length > 0) {
	// 		this.reelAnimations[this.reelAnimations.length -1].AddOnCompleteCallback(() => anim.OnPreviousReelSpinEnd());
	// 	}

	// 	anim.AddOnCompleteCallback(() => this.ReelFinished());

	// 	this.reelAnimations.push(anim);	
	// }

	// public AddReelAnimations(anims: ReelSpinAnimation[]): void {
	// 	// connect reel animations 
	// 	if (this.reelAnimations.length > 0) {
	// 		this.reelAnimations[this.reelAnimations.length -1].AddOnCompleteCallback(() => anim.OnPreviousReelSpinEnd());
	// 	}

	// 	anim.AddOnCompleteCallback(() => this.ReelFinished());

	// 	this.reelAnimations.push(anim);	
	// }

	public ReelFinished(anim: S2_ReelSpinAnimation): void {
		// Log.Debug(this.logGroup, `Column ${anim.ColumnIndex} finished`);
		this.reelsFinished++;

		if (this.reelsFinished == this.reelAnimations.length) {
			this.OnComplete();
		}
	}

	public Start(): void {
		//this.targetsSet = false;
		this.stopRequested = false;
		this.reelsFinished = 0;

		for (let i = 0; i < this.reelAnimations.length; i++) {
			this.reelAnimations[i].Start();
		}

		this.OnStart();
	}

	// public SetTargets(targets: SpinTargetParams[]): void {
	// 	if (targets.length != this.reelConfig.length) {
	// 		Log.Error(this.logGroup, "Expected " + this.reelConfig.length + " targets, got " + targets.length);
	// 		return;
	// 	}

	// 	this.targetsSet = true;

	// 	for (let animIndex = 0; animIndex < this.reelAnimations.length; animIndex++) {
	// 		this.reelAnimations[animIndex].SetTarget(targets[animIndex].anticipation);
	// 	}
	// }

	public SetTargets(anticipation: boolean[])
	{
		for (let i = 0; i < this.reelAnimations.length; i++)
		{
			this.reelAnimations[i].SetTarget(!!anticipation[i]);
		}
	}

	public Update(): void {
		for (let i = 0; i < this.reelAnimations.length; i++) {
			this.reelAnimations[i].Update();
		}
	}

	// callback will be called, when spin starts
	public AddOnStartCallback(callback: S2_SpinCallback) {
		this.onStartCallbacks.push(callback);
	}

	private OnStart(): void {
		for (let i = 0; i < this.onStartCallbacks.length; i++) {
			this.onStartCallbacks[i]();
		}
	}

	// callback will be called, when win nanimation has completed
    public AddOnCompleteCallback(callback: S2_SpinCallback) {
        this.onCompleteCallbacks.push(callback);
    }

    private OnComplete(): void {
        for (let i = 0; i < this.onCompleteCallbacks.length; i++) {
            this.onCompleteCallbacks[i]();
        }
    }

    public RequestStop(reelIndex: number = -1): void {
    	if (!this.stopRequested) {


    		// are we stopping all reels, or individual?
    		if (reelIndex == -1) {
				// stop all reels

	    		// check, if all reels are ready to stop
	    		let allReelsStopAvailable = true;
	    		for (let i = 0; i < this.reelAnimations.length; i++) {
	    			if (!this.reelAnimations[i].CheckStopAvailable()) {
	    				allReelsStopAvailable = false;
	    				break;
	    			}
	    		}

	    		// stop all reels only, if all of them are available to stop
	    		if (allReelsStopAvailable) {
	    			this.stopRequested = true;
					for (let i = 0; i < this.reelAnimations.length; i++) {
			    		this.reelAnimations[i].RequestStop();
			    	}
	    		}
	    		else {
			    	// Log.Debug(this.logGroup, "Can't request stop, not all reels are ready to stop");
			    }
			}

			// are we stopping specific reel?
			else if (reelIndex >= 0 && reelIndex < this.reelAnimations.length) {

				// make sure stop is available on this reel
				if (this.reelAnimations[reelIndex].CheckStopAvailable()) {
					this.reelAnimations[reelIndex].RequestStop();
				}
				else {
					// Log.Debug(this.logGroup, "Stop request on reel " + reelIndex + " not available yet");
				}
			}
			else {
				// Log.Debug(this.logGroup, "Expected reel index -1 or [0.." + (this.reelAnimations.length -1) + "], but got " + reelIndex);
			}
	    }
	    else {
	    	// Log.Debug(this.logGroup, "Stop already requested");
	    }
    }

	public Destroy()
	{
		this.reelAnimations.forEach(anim => anim.Destroy());
		this.reelConfig = null;
		this.reelAnimations = null;
		this.onStartCallbacks = null;
		this.onCompleteCallbacks = null;
	}
}
// }